import firebase from 'firebase/app';
import 'firebase/firestore';
import { useFirestoreQuery } from './useFirestoreQuery';

export function useHighscores() {
  return useFirestoreQuery<Game.Highscore[]>(
    firebase
      .firestore()
      .collection('highscores')
      .orderBy('score', 'desc')
      .limit(12)
  );
}
